import classes, { mergeClassNames } from "@bokio/utils/classes";

import * as styles from "./loading.scss";

interface LoadingTextProps {
	width?: string;
	height?: string;
	dark?: boolean;
	inline?: boolean;
	className?: string;
}

export const LoadingText = (props: LoadingTextProps) => {
	const customStyle = {
		height: props.height || "20px",
		// eslint-disable-next-line react-hooks/purity -- SS 2025-10-13 This lint error should be fixed in the future. Existing usages were disabled just to simplify merging lint rules upgrade.
		width: props.width || Math.round(Math.random() * 50 + 40) + "%",
		opacity: props.dark ? 0.5 : 0.2,
	};

	const classNames = classes(styles, "placeholder", {
		placeholderInline: props.inline,
	});

	return <div className={mergeClassNames(classNames, props.className)} style={customStyle} />;
};
